import { useState, useContext } from "react";
import { Context } from "../context/DataContext";
import useCustomerBlock from "@shared/hooks/useCustomerBlock";
import RenderDisabledCustomer from "@shared/components/RenderDisabledCustomer";
import Loading from "@shared/components/Loading";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import RouteModify from "./RouteModify";
import RouteConfig from "./RouteConfig";
// import AccessCodes from "./AccessCodes";
import Aperturas from "./Aperturas";
import RenderUserRestriction from "../components/RenderUserRestriction";
// import AtrasosLetter from "./AtrasosLetter";
// import Contract from "./Contract";

const Settings = () => {
  const { state } = useContext(Context);
  const { user, route, restritec_users } = state;
  const [selectedTab, setSelectedTab] = useState(0);
  const block = useCustomerBlock(route?.user_id);

  if (restritec_users.includes(+user.user_id)) return <RenderUserRestriction />;

  if (block.isChecking) return <Loading />;
  if (block.isBlocked) return <RenderDisabledCustomer {...block.disabledProps} />;

  const handleTabChange = (event, newTab) => {
    setSelectedTab(newTab);
  };

  return (
    <>
      <Tabs
        textColor="primary"
        variant="scrollable"
        scrollButtons="auto"
        value={selectedTab}
        onChange={handleTabChange}>
        <Tab label="Ruta" />
        <Tab label="Configuaciones" />
        {/* <Tab label="Codigo Aceso" /> */}
        <Tab label="Apertura" />
        {/* <Tab label="Contrato" /> */}
        {/* <Tab label="Carta de Atraso" />
        <Tab label="Carta de Saldo" /> */}
      </Tabs>

      {selectedTab === 0 && <RouteModify />}
      {selectedTab === 1 && <RouteConfig />}
      {/* {selectedTab === 2 && <AccessCodes />} */}
      {selectedTab === 2 && <Aperturas />}
      {/* {selectedTab === 1 && <Contract />}
      {selectedTab === 2 && <AtrasosLetter />} */}
    </>
  );
};

export default Settings;
